var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.253,
    height: 11.963,
    viewBox: "0 0 12.253 11.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#78849e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.1 -11.962)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.11,12.118h0a.572.572,0,0,0-.6-.12l-10.253,4.11a.57.57,0,0,0-.359.523.534.534,0,0,0,.374.508l4.334,1.495L18.1,22.969a.57.57,0,0,0,.478.374h.03a.57.57,0,0,0,.523-.359l4.11-10.268A.534.534,0,0,0,23.11,12.118Zm-4.334,5.127a.541.541,0,0,0,0-.777.56.56,0,0,0-.777,0l-1.091,1.091-2.84-.972,7.682-3.079-3.094,7.667-.972-2.855Z",
    transform: "translate(-4.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.13,55.038l1.255-1.181a.564.564,0,0,1,.792.03h0a.579.579,0,0,1-.03.792L6.892,55.86a.564.564,0,0,1-.792-.03",
    transform: "translate(0 -35.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.908,69.38,10.95,71.218a.564.564,0,0,1-.792-.03h0a.564.564,0,0,1,.03-.792l1.958-1.838a.564.564,0,0,1,.792.03h0A.564.564,0,0,1,12.908,69.38Z",
    transform: "translate(-3.325 -48.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.058,79.731a.564.564,0,0,1,.03-.792l1.255-1.181a.564.564,0,0,1,.792.03h0a.564.564,0,0,1-.03.792L30.85,79.76",
    transform: "translate(-20.251 -55.835)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIco);
export default __webpack_public_path__ + "static/media/submit_ico.d48c06ecda9f81a8335d8fff6bef0c4f.svg";
export { ForwardRef as ReactComponent };